import FormControl from '@mui/material/FormControl';
import { Box, FormControlLabel, Tabs, TextField, Checkbox, Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useColors } from "../../../../Context/ColorsContext"
import LoopIcon from '@mui/icons-material/Loop';
import { MediaQuerys } from "../../../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const Label = styled('label')(({nextline, istitle}) => {
    const { colors } = useColors();
    return {
        fontWeight:'bold',
        paddingRight:'5px',
        display: nextline ? 'block' : 'inherit',
        color: istitle ? colors.blue : colors.blackFont,
        paddingLeft: istitle ? 10 : 0,
        textTransform: istitle ? 'uppercase' : 'none',
        [desktop]: {
            fontSize: '0.85rem'
        }
    }
})

export const CustomTabs = styled(Tabs)(() => {
    const { colors } = useColors();
    return {
        '&.MuiButtonBase-root-MuiTab-root .Mui-selected': {
            color: `${colors.green} !important`
        },
        '.Mui-selected': {
            color: `${colors.green} !important`
        },
        '.MuiButtonBase-root': {
            fontWeight: 'bold',
            fontSize: '1.2rem',
            fontFamily: 'Montserrat, sans-serif',
            textTransform: 'inherit'
        },
    }
});

export const FormLabel = styled(FormControlLabel)(() => ({
    '.MuiTypography-root': {
        fontWeight: 'bold',
        fontSize: '1.2rem'
    }
}));

export const IconContainer = styled('div')(() => ({
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
    padding: 10
}));

export const IconLoop = styled(LoopIcon)(() => {
    const { colors } = useColors();
    return {
        fontSize: 50,
        color: colors.grayFont
    }
});

export const Input = styled(TextField)(() => {
    const { colors } = useColors();
    return {
        width: '100%',
        '.MuiInputBase-root': {
            background: colors.white,
            borderRadius: 6,
            fontSize: 13,
            padding: 0
        }
    }
})

export const LineTop = styled('div')(() => {
    const { colors } = useColors();
    return {
        paddingBottom: 10,
        borderTop: `1px solid ${colors.gray}`
    }
})

export const LineBottom = styled('div')(() => {
    const { colors } = useColors();
    return {
        paddingTop: 10,
        borderBottom: `1px solid ${colors.gray}`
    }
})

export const ContainerInput = styled('div')(({ isFull }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: isFull ? '100%' : '50%',
    }
})

export const ContainerCertificates = styled('div')(({ isFull }) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: isFull ? '100%' : '33.333%',
    }
})

export const ContainerGroup = styled('div')(({ isFirsts }) => {
    return {
        display: 'flex',
        gap: '0.75rem',
        flexDirection: 'row',
        width: '100%',
        marginTop: isFirsts ? '0px' : '10px'
    }
})

export const ContainerElectricalTechnician = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginTop: '10px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        padding: 10
    }
})

export const ContainerElectricalTechnicianFields = styled('div')(() => {
    return {
        display: 'flex',
        gap: '0.75rem',
        flexDirection: 'row',
        width: '100%',
        marginTop: '10px'
    }
})

export const ContainerOnly = styled('div')(() => {
    return {
        display: 'flex',
        marginTop: '10px',
        justifyContent: 'flex-start',
        width: '100%',
    }
})

export const ContainerContent = styled('div')(() => {
    return {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

    }
})

export const ContainerBox = styled(Box)(({theme}) => {
    return {
        padding: 20,
        width: '100%',
        overflowY: 'auto',
        height: '100%',
        maxHeight: '75vh'
    }
})

export const ContainerChecks = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingTop: '15px',
        [tablet]: {
            flexDirection:'column',
            alignItems: 'flex-start',
        }
    }
})

export const CustomCheckbox = styled(Checkbox)(() => {
    const { colors } = useColors();
    return {
      color: colors.grayGraphic,
      '&.Mui-checked': {
        color: colors.buttonActionColor
      },
      '&.MuiCheckbox-indeterminate': {
        color: colors.buttonActionColor
      },
      [mobile]: {
        '.MuiListItemIcon-root': {
          minWidth: '30px !important',
        }
      }
    }
})

export const ContainerInputsDate = styled("div")(({theme, errorstart }) => ({
    '& .MuiButtonBase-root': {
        color: errorstart ? theme.palette.error.main : 'inherit', 
    },
    '& .MuiInputBase-input': {
        color: errorstart ? theme.palette.error.main : 'inherit', 
    },
    '& .css-4jnixx-MuiStack-root>.MuiTextField-root': {
        // minWidth: "80px",
    },
    '& .MuiFormLabel-root': {
        fontSize: "0.8rem",
        [desktop]: {
            fontSize: "0.75rem"
        }
    },
    '& .MuiInputBase-root': {
        height: '37px !important',
        fontSize: "0.8rem",
    },
    '& .MuiStack-root': {
        paddingTop: '0px !important',
        overflow: 'visible !important',
    },
    '& .MuiTextField-root': {
        minWidth: '100% !important',
        // width: '100% !important',
        // [desktop]: {
        //     width: '120px',
        // }
    },
}));

export const CustomFormControl = styled(FormControl)(({width}) => {
    return {
        width: '100%',
        minWidth: '120px'
    }
})

export const ContainerSelect = styled('div')(() => {
    return {
        display: 'flex',
        flexDirection: 'row',
    }
});

export const ContainerIcon = styled('div')(() => {
    const { colors } = useColors();
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '10%',
    }
})

export const UploadButton = styled(Button)(() => ({
  background: 'none',
  textAlign: 'left',
  justifyContent: 'start'
}))

export const ContainerUpload = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center'
  }
})